import { ReactElement } from "react";

import { Dialog, DialogProperties } from "../Dialog";
import { DeleteIcon } from "../Icons/Icons";

export type DeleteDialogProps = DialogProperties;

export const DeleteDialog = (properties: DeleteDialogProps): ReactElement => {
  return (
    <Dialog
      aria-label="delete dialog open button"
      buttonLabel="Archiver"
      colorScheme="danger"
      icon={<DeleteIcon />}
      {...properties}
    />
  );
};
